import React, { Component } from 'react'
import Cookies from 'universal-cookie'
import {isJaguar, isSuperadmin} from '../../utility/UserUtils'
import { getTracking, dhl, fedex, ontrac, s10, ups, usps } from 'ts-tracking-number';
import TextField from '@mui/material/TextField';
import { 
  Button,
  Stack,
  TextareaAutosize
} from '@mui/material';
export default class OrderDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      shipped: this.props.order.shipped,
      billed: this.props.order.billed,
      trackingNumberInput: null,
      trackingNumbers: props.order.tracking_numbers||[],
      bulkTrackingNumberValue: "",
      showBulkTrackingNumberImport: false,
      jobNumber: props.order.job_number
    }
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.saveOrder = this.saveOrder.bind(this);
    this.handleArchiveOrder = this.handleArchiveOrder.bind(this);
  }

  saveOrder(e, success, error) {
    e.preventDefault();
    const {order} = this.props
    const {shipped, billed, trackingNumbers} = this.state;
    const cookies = new Cookies();
    const token = cookies.get("X-CSRF-Token");
    fetch(`/orders/${order.id}`, {
      method: "PATCH",
      redirect: "manual",
      body: JSON.stringify({
        shipped: shipped,
        billed: billed,
        tracking_numbers: trackingNumbers,
        job_number: this.state.jobNumber
      }),
      headers: {
        "X-CSRF-Token": token,
        "Content-Type": 'application/json'
      }
    })
    .then(response => {
      return response.json();
    })
    .then(json => {
      console.log(json);
      if (!json.errors) {
        if (billed) {
          this.handleArchiveOrder();
        }
        success(json)
      } else {
        error(json)
      }
    });
  }

  handleArchiveOrder() {
    const {archiveOrder, order} = this.props
    archiveOrder(order.id).then(() => this.toggleDropdown())
  }

  redirectToTracking() {
    const cookies = new Cookies();
    const token = cookies.get("X-CSRF-Token");
    fetch("/orders", {
      method: "POST",
      redirect: "manual",
      body: JSON.stringify(values),
      headers: {
        "X-CSRF-Token": token,
        "Content-Type": 'application/json'
      }
    })
    .then(response => {
      return response.json();
    })
    .then(json => {
      if (json.errors == null) {
        window.location = `/orders?user_id=${user.id}`
      } else {
        alert(json.errors);
      }
    });
  }

  toggleDropdown() {
    const {open} = this.state;
    this.setState({
      open: !open
    })
  }

  renderShippingInfo() {
    const {order} = this.props
    const {shipping_address} = order
    return (
      <div>
        <b>Shipping Address:</b>
        <br />
        <br />
        {shipping_address.venue_name}
        <br />
        {shipping_address.address_line_1}
        {shipping_address.address_line_2.length > 0 && <><br />{shipping_address.address_line_2}</>}
        <br />
        {shipping_address.city + ", " + shipping_address.state_province}
        <br />
        {shipping_address.country + " " + shipping_address.postal_code}
        {shipping_address.first_name.length > 0 && <><br /><br /><b>Address to:</b> {shipping_address.first_name + " " + shipping_address.last_name}</>}
        {shipping_address.email.length > 0 && <><br/><b>Email:</b> {shipping_address.email}</>}
        {shipping_address.phone.length > 0 && <><br/><b>Phone:</b> {shipping_address.phone}</>}
        {order.arrive_by && order.arrive_by.length > 0 && <><br /><b>Arrive by:</b> {new Date(order.arrive_by).toLocaleDateString("en-US")}</>}
        {isJaguar(this.props.user) && order.additional_information_link && <><br /><b>Additional Links:</b> <a href={order.additional_information_link}>{order.additional_information_link}</a></>}
      </div>
    )
  }

  renderAdminActions() {
    const {user, order, deleteOrder} = this.props
    const {shipped, billed, jobNumber} = this.state
    if (isJaguar(user) || isSuperadmin(user)) {
      return (
        <>
          <form onSubmit={(e) => this.saveOrder(e, this.toggleDropdown, (json) => alert(json.errors))}>
            <div>Admin</div>      
            <table>
              <tr>
                <td><input type="checkbox" className="mr-2" checked={shipped} onChange={(e) => this.setState({shipped: e.target.checked})}/></td>
                <td>Shipped</td>
                
              </tr>
              <tr>
                <td><input type="checkbox" className="mr-2" checked={billed} onChange={(e) => this.setState({billed: e.target.checked})}/></td>
                <td>Billed</td>
                
              </tr>
            </table>  
            <TextField
              label="Job Number"
              className="my-4 mr-4"
              id={`orders-job-number-${order.id}`}
              name={`job_number`}
              value={jobNumber}
              size="small"
              onChange={(e) => {
                this.setState({jobNumber: e.target.value})
              }}
            />   
            <br />
            {!order.archived && <><button className="btn-outlined" type="button" onClick={this.handleArchiveOrder}>Archive</button><br /><br /></>}
            <button className="btn-outlined mr-2" type="button" onClick={() => deleteOrder(order.id)}>Delete</button>
            <button className="btn-outlined" type="submit">Save</button>
          </form>
        </>
      )
    }
  }

  renderTracking() {
    const {order, user} = this.props
    const { trackingNumbers, showBulkTrackingNumberImport, jobNumber} = this.state

    return (
      <>
        <b>Tracking:</b>
        <br/>
        {isJaguar(user) && (
          <>
            <Button 
              onClick={() => this.setState({trackingNumbers: [...trackingNumbers, ""]})}
            >+ Add Tracking Number</Button>
            <Button 
              type="button"
              onClick={() => {
              this.setState({
                showBulkTrackingNumberImport: !showBulkTrackingNumberImport
              })
              }}
            >
              Bulk Import Tracking Numbers
            </Button>
     
            <br/>
            {this.renderBulkTrackingNumberImport()}
            <br/>
          </>
        )}
        { 
          trackingNumbers.map((trackingNumber, index) => 
            this.renderTrackingNumber(trackingNumber, index)
          )
        } 
        {isJaguar(user) && (
          <>
            <br/>
            <span> Please remember to save after adding tracking numbers and job number</span>
          </>
        )}

        
      </>
    )
  }

  renderBulkTrackingNumberImport() {
    const { showBulkTrackingNumberImport, bulkTrackingNumberValue } = this.state
    if(showBulkTrackingNumberImport) {
      return (
        <div className="form-group">
          <label htmlFor="bulkTrackingNumber">Bulk Import Tracking Numbers (One Per Line)</label>
          <TextField
            type="textarea"
            rows={5}
            name="bulkTrackingNumber"
            id="bulkTrackingNumber"
            multiline
            disabled={!isJaguar(this.props.user)}
            minRows={5}
            maxRow={1000}
            sx={{
              width: "100%"
            }}
            onChange={(e) => this.setState({
              bulkTrackingNumberValue: e.target.value
            })}
          />
          <Stack direction="row" spacing={1} className="mt-1">
            <Button
              type="button"
              variant="contained"
              onClick={() => {
                const newTrackingNumbers = bulkTrackingNumberValue.split("\n").filter(x=>x && x.length > 0);
                this.setState({
                  trackingNumbers: this.state.trackingNumbers.concat(newTrackingNumbers),
                  showBulkTrackingNumberImport: false,
                  bulkTrackingNumberValue: ""
                })
              }}
            >
              Import
            </Button>
            <Button
              type="button"
              variant="outlined"
              onClick={() => {
                this.setState({
                  showBulkTrackingNumberImport: false
                })
              }}
            >
              Cancel Bulk Import
            </Button>
          </Stack>
        </div>
      )
    }
  }

  renderTrackingNumber(trackingNumber, index) {
    const {order} = this.props
    const { trackingNumbers } = this.state
    //Render Input to edit tracking number and button to delete tracking number

    const trackingInfo = trackingNumber ? getTracking(trackingNumber) : null
    let url = ""
    url = trackingInfo && trackingInfo.trackingUrl ? trackingInfo.trackingUrl.replace("%s",  trackingNumber) : ""
    return (
      <div className="mt-2 flex" key={`orders-tracking-number-${order.id}`+index}>
        <TextField
          id={`orders-tracking-number-${order.id}`+index}
          name={`orders[tracking_numbers_attributes][${index}][number]`}
          value={trackingNumber}
          size="small"
          onChange={(e) => {
            const newTrackingNumbers = [...trackingNumbers]
            newTrackingNumbers[index] = e.target.value
            this.setState({trackingNumbers: newTrackingNumbers})
          }}
        />
        <Button
          onClick={() => {
            const newTrackingNumbers = [...trackingNumbers]
            newTrackingNumbers.splice(index, 1)
            this.setState({trackingNumbers: newTrackingNumbers})
          }}
        >
          x
        </Button>
        <a href={url} target="_blank">
          <Button
            disabled={!url}
          >
          {url ? "Tracking Info" : "Tracking Link Not Found"}
          </Button>
        </a>
      </div>
    )
  }

  renderOrderShippingStatus() {
    const {shipped} = this.state;
    if (shipped) {
      return (
        <div className='order-dropdown-status-shipped'>
          Shipped
        </div>
      )
    } else {
      return (
        <div className='order-dropdown-status-in-progress'>
          In Progress
        </div>
      )
    }
  }

  render() {
    const {open} = this.state;
    const {order, user} = this.props;
    const {order_items, renter} = order;
    const created_by = order_items[0] ? order_items[0].user : {user: {first_name: "N/A"}};
    return (
      <div className="order-dropdown-container">
        <div className='order-dropdown-row' onClick={this.toggleDropdown}>
          <div className='order-dropdown-number'>
            { !order.archived ? <>Order #{order.id}</> : <i>Archived - Order#{order.id}</i> }
          </div>
          <div className="order-dropdown-row-right">
            <div className='order-dropdown-status-container'>
              <div className='order-dropdown-status'>
                {this.renderOrderShippingStatus()}
              </div>
            </div>
            {user.role !== 'client' &&
              <div className='order-user-renter-info'>
                Renter: {renter ? renter.name : "N/A"}
                <br />
                Created by: {created_by.first_name + " " + created_by.last_name}
              </div>
            }
            <div>
              <span class={`fas fa-caret-${open ? "down" : "left"}`}></span>
            </div>
          </div>
        </div>
        {open &&
          <div className='order-dropdown'>
            <div className='order-dropdown-items'>
              <label>
                Order Items:
              </label>
              <ul>
                {order_items.map(order_item => (<li><a href={`/items/${order_item.item.id}`}>{order_item.item.name}</a> x {order_item.quantity}</li>))}  
              </ul>
              <br />
              <div>
                Created: {new Date(order.created_at).toLocaleString('en-US')}
              </div>
              <br />
              {this.renderAdminActions()}
            </div>  
            <div className='order-dropdown-tracking'>
              {this.renderShippingInfo()}
              <br />
              {this.renderTracking()}
            </div>
          </div>
        }
      </div>
    )
  }
}
